<template>
    <div v-if="loaded">
        <rkm-area
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="maxDate"
                            :min-date="minDate"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!model.unidadeId"
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :disabled="!hasPeriodo"
                            :repository="repositories.relatorioTempoAtendimento"
                            :request-query-string-params="pacienteSearchParams"
                            :search-fields="pacienteSearchFields"
                            label="Paciente"
                            placeholder="Nome, CNS, CPF ou Prontuário"
                            text-field="nome"
                            v-model="model.paciente"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.especialidades"
                            @change="handleEspecialidadeChange"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.ocupacoes"
                            @change="handleOcupacaoChange"
                            default-option-text="Todos"
                            label="CBO"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="8">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.cids"
                            @change="handleCidChange"
                            default-option-text="Todos"
                            label="CID"
                            show-default-option
                            text-field="descricao"
                            v-model="model.cidId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.prioridades"
                            @change="clearResult"
                            default-option-text="Todas"
                            label="Prioridade"
                            show-default-option
                            text-field="nome"
                            v-model="model.prioridadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.opcoesEntrada"
                            @change="clearResult"
                            default-option-text="Todas"
                            label="Opção de entrada"
                            show-default-option
                            text-field="nome"
                            v-model="model.opcaoEntrada"
                            value-field="nome"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.servicos"
                            @change="clearResult"
                            default-option-text="Todos"
                            label="Serviço"
                            show-default-option
                            text-field="nome"
                            v-model="model.servicoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.tiposAtendimento"
                            @change="clearResult"
                            default-option-text="Todos"
                            label="Tipo de atendimento"
                            show-default-option
                            v-model="model.tipoAtendimento"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!hasPeriodo"
                            :options="form.ocorrencias"
                            @change="clearResult"
                            default-option-text="Todas"
                            label="Ocorrência"
                            show-default-option
                            v-model="model.ocorrencia"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="clear"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area title="Resultado">
            <template v-slot:trailing>
                <rkm-button
                    :disabled="atendimentos.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="atendimentos.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="atendimentoFields"
                :items="atendimentos"
                :sort-by="sortBy"
                :sort-compare="sortCompare"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
            >
                <template v-slot:cell(cidsCiaps)="{ value }">
                    {{ value.length > 0 ? value.join(' | ') : '-' }}
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="$refs.ModalDetalhe.open(item)"
                        color="primary"
                        small
                        title="Exibir detalhes"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>

            <div
                v-if="totalizadores && totalizadores.totalNaoExibidosSigilo > 0"
                class="text-muted"
            >
                {{ totalizadores.totalNaoExibidosSigilo }} atendimentos não exibidos por sigilo
            </div>
        </rkm-area>

        <rkm-area
            v-if="totalizadores"
            no-margin-top
            title="Totalizadores"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Atendimentos"
                        v-model="totalizadores.totalAtendimentos"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Pacientes"
                        v-model="totalizadores.totalPacientes"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Total de espera"
                        tooltip-top="Somatório do tempo de espera de todos os atendimentos"
                        v-model="totalizadores.totalTempoEspera"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Total de atendimento"
                        tooltip-top="Somatório do tempo de atendimento de todos os atendimentos"
                        v-model="totalizadores.totalTempoAtendimento"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Média de espera"
                        tooltip-top="Somatório do tempo de espera de todos os atendimentos / quantidade de atendimentos"
                        v-model="totalizadores.mediaEspera"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Média de atendimento"
                        tooltip-top="Somatório do tempo de atendimento de todos os atendimentos / quantidade de atendimentos"
                        v-model="totalizadores.mediaAtendimento"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Média de permanência"
                        tooltip-top="Somatório do tempo total de todos os atendimentos / quantidade de atendimentos"
                        v-model="totalizadores.mediaPermanencia"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <ModalDetalhe
            :fields="detalheFields"
            ref="ModalDetalhe"
        />
    </div>
</template>

<script>
// Components.
import ModalDetalhe from './components/detalhe/Modal'

// Mixins.
import { repository, error, stringCase, file } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

export default {
    components: {
        ModalDetalhe,
    },
    computed: {
        validations() {
            return {
                periodo: { required: true },
            }
        },
        minDate() {
            if (this.model.periodo.end === null) {
                return null
            }

            return this.others.moment(this.model.periodo.end).subtract(1, 'month').format('DD/MM/YYYY')
        },
        maxDate() {
            const dataAtual = this.others.moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (this.model.periodo.start === null) {
                return dataAtual.format('DD/MM/YYYY')
            }

            const max = this.others.moment(this.model.periodo.start).add(1, 'month')

            return (max > dataAtual ? dataAtual : max).format('DD/MM/YYYY')
        },
        hasPeriodo() {
            return this.model.periodo.start !== null && this.model.periodo.end !== null
        },
        pacienteSearchParams() {
            return {
                periodo: this.hasPeriodo ? this.getPeriodo() : null,
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
            }
        },
        pacienteSearchFields() {
            return [
                { key: 'cidadao.nome', searchable: true },
                { key: 'cidadao.cns', searchable: true },
                { key: 'cidadao.cpf', searchable: true },
                { key: 'paciente.prontuario', searchable: true },
            ]
        },
        atendimentoFields() {
            return [
                { key: 'pacienteProntuario', label: 'Prontuário', class: 'col-min', sortable: true },
                { key: 'pacienteNome', label: 'Paciente', sortable: true },
                { key: 'especialidadeNome', label: 'Especialidade', sortable: true, formatter: v => v === null ? '-' : v },
                { key: 'data', label: 'Data', class: 'col-min text-center', sortable: true },
                { key: 'horarioAgendado', label: 'Horário agendado', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'horarioChegada', label: 'Horário de chegada', class: 'col-min text-center' },
                { key: 'atraso', label: 'Atraso', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'cidsCiaps', label: 'CID/CIAP' },
                { key: 'tempoTotal', label: 'Tempo total', class: 'col-min text-center', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
        detalheFields() {
            return [
                { key: 'setorNome', label: 'Setor' },
                { key: 'tipoAtendimento', label: 'Tipo de atendimento', formatter: v => v === null ? '-' : v },
                { key: 'usuarioNome', label: 'Profissional', formatter: v => v === null ? '-' : v },
                { key: 'ocupacaoCodigo', label: 'CBO', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'data', label: 'Data', class: 'col-min text-center' },
                { key: 'horarioChegada', label: 'Chegada', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'horarioInicio', label: 'Início', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'horarioConclusao', label: 'Conclusão', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'tempoEspera', label: 'Espera', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
                { key: 'tempoAtendimento', label: 'Atendimento', class: 'col-min text-center', formatter: v => v === null ? '-' : v },
            ]
        },
    },
    created() {
        this.repositories = {
            relatorioTempoAtendimento: this.getConectaSusRepository('ambulatorio.relatorioTempoAtendimento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            exportacao: this.getConectaSusRepository('exportacao.ambulatorio'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        limpandoFiltros: false,
        additionals: null,
        form: null,
        model: null,
        atendimentos: [],
        totalizadores: null,
        sortBy: 'data',
        sortDesc: false,
        unwatchers: {
            unwatchPeriodo: null,
            unwatchPaciente: null,
        },
        others: { moment },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioTempoAtendimento.create()
                .then(({ data }) => {
                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {
            this.unwatchers.unwatchPeriodo = this.$watch('model.periodo', {
                deep: true,
                handler: this.handlePeriodoChange,
            })

            this.unwatchers.unwatchPaciente = this.$watch('model.paciente', () => this.handlePacienteChange())
        },
        removeWatchers() {
            this.unwatchers.unwatchPeriodo()
            this.unwatchers.unwatchPaciente()
        },
        handlePeriodoChange(periodo) {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.especialidades = []
            this.form.ocupacoes = []
            this.form.cids = []
            this.form.ocorrencias = []

            this.clearModelFrom('unidade')
            this.clearResult()

            if (periodo.start === null || periodo.end === null) return

            this.loadFromUnidade()
        },
        handleUnidadeChange() {
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.especialidades = []
            this.form.ocupacoes = []
            this.form.cids = []
            this.form.ocorrencias = []

            this.clearModelFrom('infraestrutura')
            this.clearResult()
            this.loadFromInfraestrutura()
        },
        handleInfraestruturaChange() {
            this.form.usuarios = []
            this.form.especialidades = []
            this.form.ocupacoes = []
            this.form.cids = []
            this.form.ocorrencias = []

            this.clearModelFrom('usuario')
            this.clearResult()
            this.loadFromUsuario()
        },
        handleUsuarioChange() {
            this.form.especialidades = []
            this.form.ocupacoes = []
            this.form.cids = []
            this.form.ocorrencias = []

            this.clearModelFrom('paciente')
            this.clearResult()
            this.loadFromEspecialidade()
        },
        handlePacienteChange() {
            if (this.limpandoFiltros) return

            this.form.especialidades = []
            this.form.ocupacoes = []
            this.form.cids = []
            this.form.ocorrencias = []

            this.clearModelFrom('especialidade')
            this.clearResult()
            this.loadFromEspecialidade()
        },
        handleEspecialidadeChange() {
            this.form.ocupacoes = []
            this.form.cids = []
            this.form.ocorrencias = []

            this.clearModelFrom('ocupacao')
            this.clearResult()
            this.loadFromOcupacao()
        },
        handleOcupacaoChange() {
            this.form.cids = []
            this.form.ocorrencias = []

            this.clearModelFrom('cid')
            this.clearResult()
            this.loadFromCid()
        },
        handleCidChange() {
            this.form.ocorrencias = []

            this.clearModelFrom('ocorrencia')
            this.clearResult()
            this.loadFromOcorrencia()
        },
        clearModelFrom(nivel) {

            this.limpandoFiltros = true

            const niveis = [
                'unidade', 'infraestrutura', 'usuario', 'paciente',
                'especialidade', 'ocupacao', 'cid', 'ocorrencia',
            ]

            const campos = {
                unidade: 'unidadeId',
                infraestrutura: 'infraestruturaId',
                usuario: 'usuarioId',
                paciente: 'paciente',
                especialidade: 'especialidadeId',
                ocupacao: 'ocupacaoId',
                cid: 'cidId',
                ocorrencia: 'ocorrencia',
            }

            niveis.slice(niveis.indexOf(nivel)).forEach(n => {
                this.model[campos[n]] = null
            })

            this.model.prioridadeId = null
            this.model.opcaoEntrada = null
            this.model.servicoId = null
            this.model.tipoAtendimento = null

            this.$nextTick().then(() => { this.limpandoFiltros = false })
        },
        loadFromUnidade() {
            this.loadFrom('unidades', {})
        },
        loadFromInfraestrutura() {
            this.loadFrom('infraestruturas', {
                unidadeId: this.model.unidadeId,
            })
        },
        loadFromUsuario() {
            this.loadFrom('usuarios', {
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
            })
        },
        loadFromEspecialidade() {
            this.loadFrom('especialidades', {
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                pacienteId: this.model.paciente?.id ?? null,
            })
        },
        loadFromOcupacao() {
            this.loadFrom('ocupacoes', {
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                pacienteId: this.model.paciente?.id ?? null,
                especialidadeId: this.model.especialidadeId,
            })
        },
        loadFromCid() {
            this.loadFrom('cids', {
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                pacienteId: this.model.paciente?.id ?? null,
                especialidadeId: this.model.especialidadeId,
                ocupacaoId: this.model.ocupacaoId,
            })
        },
        loadFromOcorrencia() {
            this.loadFrom('ocorrencias', {
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                pacienteId: this.model.paciente?.id ?? null,
                especialidadeId: this.model.especialidadeId,
                ocupacaoId: this.model.ocupacaoId,
                cidId: this.model.cidId,
            })
        },
        loadFrom(loadFrom, filtros) {
            const params = {
                loadFrom,
                periodo: this.getPeriodo(),
                ...filtros,
            }

            this.setLoading()

            this.repositories.relatorioTempoAtendimento.list(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    Object.keys(data).forEach(key => {
                        this.form[key] = data[key]
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            this.setLoading()

            this.repositories.relatorioTempoAtendimento.index(this.prepareData())
                .then(({ data }) => {
                    this.atendimentos = data.atendimentos
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clear() {
            this.removeWatchers()

            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.especialidades = []
            this.form.ocupacoes = []
            this.form.cids = []
            this.form.ocorrencias = []

            this.model.periodo = { start: null, end: null }
            this.clearModelFrom('unidade')

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
            this.addWatchers()
            this.clearResult()
        },
        clearResult() {
            this.atendimentos = []
            this.totalizadores = null
        },
        sortCompare(a, b, key) {
            if (key !== 'data') {
                return false
            }

            const dataA = this.others.moment(a[key], 'DD/MM/YYYY')
            const dataB = this.others.moment(b[key], 'DD/MM/YYYY')

            if (dataA > dataB) return 1
            if (dataA < dataB) return -1

            return 0
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        print() {
            this.setLoading()

            this.repositories.impressao.relatorioTempoAtendimento(this.prepareData(true))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            this.repositories.exportacao.relatorioTempoAtendimento(this.prepareData(true))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData(isPrintExport = false) {
            const params = {
                periodo: this.getPeriodo(),
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                pacienteId: this.model.paciente?.id ?? null,
                especialidadeId: this.model.especialidadeId,
                ocupacaoId: this.model.ocupacaoId,
                cidId: this.model.cidId,
                prioridadeId: this.model.prioridadeId,
                opcaoEntrada: this.model.opcaoEntrada,
                servicoId: this.model.servicoId,
                tipoAtendimento: this.model.tipoAtendimento,
                ocorrencia: this.model.ocorrencia,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            if (isPrintExport) {
                params.columns = this.atendimentoFields
                    .filter(f => f.key !== 'actions')
                    .map(f => ({ key: this.camelToSnake(f.key), label: f.label, class: f.class }))

                params.columnsDetalhe = this.detalheFields
                    .map(f => ({ key: this.camelToSnake(f.key), label: f.label, class: f.class }))
            }

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        getPeriodo() {
            return {
                start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
            }
        },
    },
    mixins: [repository, error, stringCase, file],
}
</script>
